import { memoizeWith, identity } from 'ramda';

const mem = memoizeWith(identity);

export const isModalOpenedSelector = mem((type) => (state) => state.modal.type === type);
export const modalTypeOpenedSelector = (state) => state.modal.type;
export const modalDataSelector = (state) => state.modal.data;
export const loadingSelector = (state) => Boolean(state.modal.loading);
